import { Component} from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, ToastController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';
// import { BarcodeScanner } from '@ionic-native/barcode-scanner';
// import { BrowserQRCodeReader } from '@zxing/library';
// import { Camera, CameraOptions } from '@ionic-native/camera';

import { LoginPage } from '../login/login';
import { WithdrawalconfirmPage } from '../withdrawalconfirm/withdrawalconfirm';
import { WithdrawalpointlistPage } from '../withdrawalpointlist/withdrawalpointlist';

/**
 * Generated class for the WithdrawalpointPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-withdrawalpoint',
  templateUrl: 'withdrawalpoint.html',
})
export class WithdrawalpointPage {
    loginId: string;
	api_key: string;
	version: string;

    from: string;
	wallet_address: string;
	bank: string;
	bank_list: any = [];
	address: string;
	account_holder: string;
	balance: any = [];
	min: string = '0';
	max: string = '0';
    remain: string;
	ether: string;
	txid: string;
	fee_amount: string;
	fee: string;

	parts: any;
	value: string = '';
    coin_unit: string;
    unit: string;
    cash_unit: string;
	target_wallet_address: string;
    
    texts: any = [];
	language : string;
	imagePath:string;

    isSend : boolean = true;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private http: HttpService,
		public modalCtrl: ModalController,
		public alertCtrl:AlertController,
		public toastCtrl: ToastController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
		public app: App
		) {
			this.target_wallet_address = "";
			this.value = "";
            this.from = navParams.get("from");
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "withdrawalcash");
        this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
        this.coin_unit = localStorage.getItem("coin_unit");
        this.unit = localStorage.getItem("unit");
        this.cash_unit = localStorage.getItem("cash_unit");
        
		this._init_bank();
		this._init();
        
        this._get_texts();       

	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).withdrawalcash;
	}

    keyDown(event) {
        if (this.value == undefined || this.value == null) {
			var tmps: string = "";
		} else {
			tmps = this.value;
		}
		
		this.value = tmps.replace(/[^0-9]/g, "");
    }

    keyUp() {
        if(this.value != null || this.value != "") {
            let tmps = this.value;
            this.value = tmps.replace(/[^0-9]/g, "");
            
            // this.floor();
        } else {

        }
        
	}
    
    // floor() {
    //     let url = "withdraw/base/index/floor";
    //     let send_data = JSON.stringify({ 
    //         api: this.api_key,
	// 		language: this.language,
	// 		version: this.version,
	// 		value: this.value
    //     });
        
    //     this.http.post_floor(url, send_data).then((res: any) => {
    //         if(res.result == "OK"){
    //             // this.balance = res.balance;
	// 			this.remain = res.remain;
	// 			this.value = res.value;
	// 			this.fee_amount = res.fee;
	// 			// this.ether = res.ether;

    //         } else if(res.result ==="LOGOUT"){
	// 			let alert = this.alertCtrl.create({
	// 				message: res.message,
	// 				buttons: ['OK']
	// 			});
	// 			alert.present();
	// 			localStorage.removeItem("loginId");
	// 			localStorage.removeItem("api_key");
	// 			this.app.getRootNav().setRoot(LoginPage);
			
	// 		}else{

    //         } 
    //     },(err)=>{	
	// 		//// HTTP 에러인 경우
	// 		let alert = this.alertCtrl.create({
	// 			message: err,
	// 			buttons: ['OK']
	// 		});
	// 		alert.present();
		
	// 	});
    // }

	onSend(){
        // let alert = this.alertCtrl.create({
        //     message: this.texts.alertM_ready,
        //     buttons: ['OK']
        // });
        // alert.present();

		this.isSend = false;

        if (!this.bank || this.bank.length == 0) {
			const toast = this.toastCtrl.create({
				message:  this.texts.toastM_bank,
				duration: 2000,
				position: 'middle'
			});
            toast.present();
            this.isSend = true;
			return false;
		}

		if (!this.address || this.address.length == 0) {
			const toast = this.toastCtrl.create({
				message:  this.texts.toastM_wallet,
				duration: 2000,
				position: 'middle'
			});
            toast.present();
            this.isSend = true;
			return false;
		}

		if (!this.value || this.value.length == 0 || this.value =="0") {
			const toast = this.toastCtrl.create({
				message:  this.texts.toastM_amount,
				duration: 2000,
				position: 'middle'
			});
            toast.present();
            this.isSend = true;
			return false;
		}

        let modal = this.modalCtrl.create(WithdrawalconfirmPage, {bank: this.bank, account_number: this.address, value: this.value, account_holder: this.account_holder});
            modal.present();
            modal.onDidDismiss( data => {
            if (data == 'ok') {
                let alert = this.alertCtrl.create({
                    message: this.texts.alertM_completed,
                    buttons: [
                        {
                            text: 'OK',
                            handler: () => {
                                this.isSend = true;
                                if (this.from == 'list') {
                                    this.navCtrl.pop();

                                } else {
                                    this.navCtrl.push(WithdrawalpointlistPage, {segment : 'pending'});

                                }
                            }
                        }
                    ]
                });
                alert.present();

                this._init();

            } else {
                this.isSend = true;
                this._init();
            }
        });

        
	}

    _init() {
		//// 서버로부터의 데이타
        let url = "withdraw/point";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this.bank = res.bank
				this.address = res.account_number;
				this.account_holder = res.account_holder;
				this.remain = res.remain;
				this.balance = res.balance;
				this.min = res.min;
				this.max = res.max;
				this.fee = res.fee;
				
				// this.floor();
			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this.navCtrl.pop();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
                this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
			
		},(err)=>{	
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: err,
				buttons: ['OK']
			});
			alert.present();
		
		});
	}

    _init_bank() {
        let url = "common/bank";
        let body = JSON.stringify({
            language: this.language
        });
        this.http.post(url, body).then((res:any)=>{
            if(res.result=="OK"){
                this.bank_list = res.bank;

            } else if(res.result ==="LOGOUT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                this.app.getRootNav().setRoot(LoginPage);
            
            } else {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
        },(err)=>{
            let alert = this.alertCtrl.create({
                message: this.texts.alertM_err,
                buttons: ['OK']
            });
            alert.present();
        });
    }
	
	onTlist() {
        if (this.from == 'list') {
            this.navCtrl.pop();

        } else {
            this.navCtrl.push(WithdrawalpointlistPage);

        }
	}
}



// WEBPACK FOOTER //
// ./src/pages/withdrawalpoint/withdrawalpoint.ts